<script>
import {
  BaseStoryCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import ActionCountElement
  from "%/dynamic-component-editor/standard-elements/action-element/ActionCountElement.vue";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import { countToShow, isCountShown } from "%/dynamic-component-editor/helpers/story-engagement.mjs";
import HideCountAtZero from "%/dynamic-component-editor/options/hide-count-at-zero";
import ButtonActionCountOptions from "%/dynamic-component-editor/bundles/button-action-count-options";
import { ENGAGEMENT_ICONS } from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "ShareCount",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.COUNTS_AND_SCORES,
    displayName: "Share Count",
    displayIcon: "material-symbols:filter-1-outline",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: ActionCountElement,
  mixins: [BaseStoryCardElementMixin],
  options: [
    new HideCountAtZero({ default: true }),
  ],
  optionBundles: [
    new ButtonActionCountOptions({ "default.icon": ENGAGEMENT_ICONS.share, "default.display-icon": "hide" }),
  ],
  computed: {
    shouldShowAction() {
      return isCountShown({
        editMode: this.editMode,
        featureOn: true,
        count: this.entity?.numShares,
        hideAtZero: this.getOptionValue(HideCountAtZero),
      });
    },
    myValue() {
      return countToShow(this.entity?.numShares, this.getOptionValue(DisplayValue));
    },
  },
  methods: {
    handleClick() {
      return;
    },
  },
};
</script>
